import { inView, animate, scroll, stagger } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    const animationFadeIn = document.querySelectorAll('.animation-fade-in');

    // Check if any blockContainer elements exist
    if (animationFadeIn.length === 0) {
        return;
    }

    animationFadeIn.forEach(component => {
        
        // Ensure blockContainerContent exists
        inView(animationFadeIn, () => {
            animate(animationFadeIn, 
                { 
                    opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                    // transform: ['translateY(40px)', 'translateY(0)'], // Slight upward movement.
                },
                { 
                    duration: 0.6, // Animation duration.
                    delay: 0.6
                }
            );
        });
    });
});